import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;
const MAIN_SQUARE_PADDING = 8;
const CHIP_LEGS_PADDING = 11.6;
const CHIP_LEG_LENGTH = 3.2;
const LEGS_ON_SIDE = 5;

const drawMainSquare = (pathBuilder: SvgPathBuilder): void => {
  pathBuilder
    .moveTo(MAIN_SQUARE_PADDING, MAIN_SQUARE_PADDING)
    .hLineTo(ICON_SIZE - MAIN_SQUARE_PADDING)
    .vLineTo(ICON_SIZE - MAIN_SQUARE_PADDING)
    .hLineTo(MAIN_SQUARE_PADDING)
    .vLineTo(MAIN_SQUARE_PADDING)
    .close();
};

const drawChipLegs = (pathBuilder: SvgPathBuilder): void => {
  const legSpacing = (ICON_SIZE - 2 * CHIP_LEGS_PADDING) / (LEGS_ON_SIDE - 1);
  for (let i = 0; i < LEGS_ON_SIDE; i += 1) {
    const chipOffset = CHIP_LEGS_PADDING + legSpacing * i;
    // top legs
    pathBuilder.moveTo(chipOffset, MAIN_SQUARE_PADDING);
    pathBuilder.vLineTo(MAIN_SQUARE_PADDING - CHIP_LEG_LENGTH);
    // bottom legs
    pathBuilder.moveTo(chipOffset, ICON_SIZE - MAIN_SQUARE_PADDING);
    pathBuilder.vLineTo(ICON_SIZE - MAIN_SQUARE_PADDING + CHIP_LEG_LENGTH);
    // left legs
    pathBuilder.moveTo(MAIN_SQUARE_PADDING, chipOffset);
    pathBuilder.hLineTo(MAIN_SQUARE_PADDING - CHIP_LEG_LENGTH);
    // right legs
    pathBuilder.moveTo(ICON_SIZE - MAIN_SQUARE_PADDING, chipOffset);
    pathBuilder.hLineTo(ICON_SIZE - MAIN_SQUARE_PADDING + CHIP_LEG_LENGTH);
  }
};

function createCloudInstanceIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const chipPathBuilder = new SvgPathBuilder();
  drawMainSquare(chipPathBuilder);
  drawChipLegs(chipPathBuilder);

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${makeTag('path', {
      d: chipPathBuilder.build(),
      fill: 'none',
      stroke: ICON_DEFAULT_FOREGROUND_COLOR,
      'stroke-width': 1.6,
      'stroke-linecap': 'round',
    })}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const cloudInstanceIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createCloudInstanceIcon,
);
